import { gql } from '@apollo/client';

export const CREATE_SIGN_NOW_ENVELOPE = gql`
  mutation Flex_CreateSignNowEnvelope($input: CreateSignNowEnvelopeInput!) {
    createSignNowEnvelope(input: $input) {
      id
      status
      signingUrl
      inviteExpiresAt
      personalizedContractId
    }
  }
`;
